export { default } from 'shared/components/context/col'
